import { withInstall } from '@lit-element/utils'

import VerificationCode from './src/verification-code.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtVerificationCode: SFCWithInstall<typeof VerificationCode> =
  withInstall(VerificationCode)
export default LtVerificationCode
